import React, { useMemo } from 'react';

import { Capitalize, calculateAge, getPublicImagePath, ia } from 'lib/helpers/utility';
import useDateTimeFormat from 'lib/hooks/useDateTimeFormat';

const PrintViewHeader = ({ practice, patient, createdAt, hiddenFields = {} }) => {
  const { formatDate } = useDateTimeFormat();
  function getAddressDisplay(address) {
    if (address && typeof address === 'object' && !ia(address)) {
      return address?.fullAddress;
    }

    if (address && typeof address !== 'number') {
      return address;
    }

    return null;
  }

  const hidePtName = useMemo(
    () => hiddenFields?.patient?.includes?.('pt_name'),
    [hiddenFields?.patient]
  );

  const hidePtAddress = useMemo(
    () => hiddenFields?.patient?.includes?.('pt_address'),
    [hiddenFields?.patient]
  );

  const detailText = useMemo(() => {
    const patientInfoParts = [
      !hiddenFields?.patient?.includes?.('pt_dob') && patient?.dob && formatDate(patient.dob),
      !hiddenFields?.patient?.includes?.('pt_age') &&
        patient?.dob &&
        `${calculateAge({ dateOfBirth: patient.dob })} years`,
      !hiddenFields?.patient?.includes?.('pt_gender') &&
        patient?.gender &&
        Capitalize(patient.gender)
    ]?.filter(Boolean);

    return ia(patientInfoParts) ? patientInfoParts.join(' • ') : '';
  }, [hiddenFields]);

  return (
    <div>
      <div className="flex items-center justify-between bg-white !py-4 !pl-6 !pr-4">
        {practice?.header_photo && (
          <div className="flex h-[90px] w-[140px] justify-start">
            <img
              className="!w-auto object-contain"
              src={getPublicImagePath(JSON.parse(practice?.header_photo).jpg, practice?.id)}
            />
          </div>
        )}
        <div className="flex items-center gap-x-2">
          <div className="ml-auto grid">
            <p className="text-right text-sm font-600 text-[#003A4B] print:text-xl">
              {practice?.displayName}
            </p>
            <p className="text-right text-xs text-[#003A4B] print:text-base">
              {getAddressDisplay(practice?.address)}
            </p>
            <p className="text-right text-xs text-[#003A4B] print:text-base">{practice?.phone}</p>
            <p className="text-right text-xs text-[#003A4B] print:text-base">{practice?.email}</p>
            <p className="text-right text-xs text-[#003A4B] print:text-base">{practice?.tax_id}</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between bg-[#003A4B] !py-3 !pl-6 !pr-4">
        <div className="grid">
          {!hidePtName && (
            <p className="text-sm font-600 text-white print:text-base print:!text-white">
              {patient?.fullName || `${patient?.f_name} ${patient?.l_name}`}
            </p>
          )}

          {detailText && (
            <p className="text-xs text-white print:text-base print:!text-white">{detailText}</p>
          )}
          {!hidePtAddress && (
            <p className="text-xs text-white print:text-base print:!text-white">
              {getAddressDisplay(patient?.userAddress)}
            </p>
          )}
        </div>
        <div className="grid">
          <p className="text-right text-sm font-600 text-white print:text-xl print:!text-white">
            {createdAt ? `Date of Service: ${formatDate(createdAt, practice?.timezone)}` : ''}
          </p>
          <p className="text-right text-xs text-white print:text-base print:!text-white">
            Chart ID: {patient?.id}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrintViewHeader;
